import { isEqual } from 'lodash';
import Vue from 'vue';
import cookie from 'util/dom/cookie';
import {
    SET_PAGE_TYPE,
    DISMISS_HOME_INTRO,
    ADD_MEDIA_ITEM,
    REMOVE_MEDIA_ITEM,
    SET_LOCATION_NAV,
    TOGGLE_MAP_NAV,
} from 'framework/vuex/mutation-types';

import * as getters from './getters';
import * as actions from './actions';


const COOKIE_NAME = 'home_intro_dismissed';


function readAndParseCookie() {
    return JSON.parse(cookie.read(COOKIE_NAME));
}


/**
 * The mutations available in the module
 */
const mutations = {
    [SET_PAGE_TYPE](state, { pageType }) {
        state.pageType = pageType;
    },
    [DISMISS_HOME_INTRO](state, { isHomeIntroDismissed }) {
        const currentValue = readAndParseCookie();

        if (currentValue !== isHomeIntroDismissed) {
            cookie.write({
                key: COOKIE_NAME,
                value: JSON.stringify(isHomeIntroDismissed),
                path: '/',
            });
        }

        state.isHomeIntroDismissed = isHomeIntroDismissed;
    },
    [ADD_MEDIA_ITEM](state, { item }) {
        state.gallery.items.push(item);
    },
    [REMOVE_MEDIA_ITEM](state, { item }) {
        const idx = state.gallery.items.findIndex(el => isEqual(el.positionId, item.positionId));

        if (~idx) {
            state.gallery.items.splice(idx, 1);
        }
    },
    [SET_LOCATION_NAV](state, { nav }) {
        Vue.set(state, 'locationNav', nav);
    },
    [TOGGLE_MAP_NAV](state, { toggle }) {
        Vue.set(state.mapNav, 'isActive', toggle);
    },
};


/**
 * The state of the module
 */
const state = {
    pageType: null,
    isHomeIntroDismissed: readAndParseCookie(),
    gallery: {
        items: [],
    },
    locationNav: {},
    mapNav: {
        isActive: false,
    },
};


export default {
    actions,
    state,
    getters,
    mutations,
};



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/framework/vuex/modules/project/index.js